export default __webpack_public_path__ + "static/media/team.9aa0eaca.png";